module.exports = __webpack_public_path__ + "img/tau.d03d4ca2.svg";